import React from 'react';
import { Box, Typography, Button, Container, useTheme } from '@mui/material';
import { motion } from 'framer-motion';
import { MdRocketLaunch } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';

const ComingSoon = () => {
  const theme = useTheme();
  const navigate = useNavigate();

  return (
    <Container maxWidth="md">
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '80vh',
          textAlign: 'center',
        }}
      >
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <Box
            sx={{
              width: 120,
              height: 120,
              borderRadius: '50%',
              bgcolor: 'rgba(44, 139, 99, 0.1)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              mb: 4,
              mx: 'auto',
            }}
          >
            <MdRocketLaunch size={60} color={theme.palette.primary.main} />
          </Box>
          <Typography
            variant="h3"
            sx={{
              fontWeight: 700,
              mb: 2,
              color: theme.palette.primary.main,
              letterSpacing: '-0.02em',
            }}
          >
            Coming Soon
          </Typography>
          <Typography
            variant="h6"
            sx={{
              color: 'text.secondary',
              mb: 4,
              maxWidth: 500,
              mx: 'auto',
              fontWeight: 400,
              lineHeight: 1.6,
            }}
          >
            We're working hard to bring you this feature. Stay tuned for updates as we continue to improve the Holding Hands portal.
          </Typography>
          <Button
            variant="contained"
            onClick={() => navigate('/')}
            sx={{
              bgcolor: theme.palette.primary.main,
              color: 'white',
              px: 4,
              py: 1.5,
              borderRadius: '8px',
              fontWeight: 600,
              textTransform: 'none',
              fontSize: '1rem',
              boxShadow: '0 4px 14px 0 rgba(44, 139, 99, 0.39)',
              '&:hover': {
                bgcolor: theme.palette.primary.darker || '#267755',
                boxShadow: '0 6px 20px rgba(44, 139, 99, 0.23)',
              },
            }}
          >
            Back to Home
          </Button>
          <Typography
            variant="body2"
            sx={{
              mt: 6,
              color: 'text.disabled',
              fontWeight: 500,
              letterSpacing: '0.05em',
              textTransform: 'uppercase',
            }}
          >
            Holding Hands • Scholarship Portal
          </Typography>
        </motion.div>
      </Box>
    </Container>
  );
};

export default ComingSoon;
